export const START_CALL_BETS = 'StartCallBets';
export const FIRST_HAND_INFORMATION = 'FirstHandCardsMessage';
